import { generateNamesObject } from '@orbis-systems/orbis-react-toolkit';

import { Card, styled } from '@mui/material';

export const accountCardClasses = generateNamesObject(
	['accountTitle', 'accountStatus', 'date', 'updatingAccount', 'titleContainer', 'formTitle'],
	'AccountCard',
);

export const StyledAccountCard = styled(Card)<{ active: boolean }>(({ theme, active }) => ({
	height: '100%',
	borderRadius: 6,
	padding: theme.spacing(3),
	paddingTop: 13,
	backgroundColor: active
		? theme.darkMode
			? '#293656'
			: '#E8ECFE'
		: theme.darkMode
		? theme.palette.analystRatings.topPercentageBadge
		: theme.palette.common.white,
	border: active
		? `2px solid ${theme.palette.primary.main}`
		: `1px solid ${theme.darkMode ? '#293656' : theme.palette.divider}`,
	'&:hover': {
		cursor: 'pointer',
	},
	[`& .${accountCardClasses.accountTitle}`]: {
		color: theme.palette.primary.main,
		fontWeight: 500,
	},
	[`& .${accountCardClasses.formTitle}`]: {
		color: theme.palette.text,
		fontWeight: 500,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: '100%',
		display: 'block',
	},
	[`& .${accountCardClasses.accountStatus}`]: {
		fontWeight: 500,
		color: theme.palette.secondary.main,
		textTransform: 'capitalize',
	},
	[`& .${accountCardClasses.date}`]: {
		color: theme.palette.secondary.main,
	},
	[`&.${accountCardClasses.updatingAccount}`]: {
		backgroundColor: active
			? theme.darkMode
				? theme.palette.divider
				: theme.palette.background.default
			: theme.darkMode
			? theme.palette.background.paper
			: theme.palette.common.white,
		border: active ? `2px solid ${theme.palette.text.secondary}` : `1px solid ${theme.palette.divider}`,

		[`& .${accountCardClasses.accountTitle}`]: {
			color: theme.palette.text.secondary,
		},
		[`& .${accountCardClasses.accountStatus}`]: {
			color: theme.palette.text.secondary,
		},
		[`& .${accountCardClasses.date}`]: {
			color: theme.darkMode ? '#47507C' : theme.palette.text.secondary,
			opacity: 1,
		},
		[`& .${accountCardClasses.titleContainer} svg path`]: {
			fill: theme.palette.text.secondary,
		},
	},
}));
